import { render } from "./PlayersOverview.vue?vue&type=template&id=e9538c7e&ts=true"
import script from "./PlayersOverview.vue?vue&type=script&lang=ts"
export * from "./PlayersOverview.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__